import { z } from 'zod'

export const AddLineItemSchema = z.object({
    cart_id: z.string().min(1),
    variant_id: z.string(),
    quantity: z.number().max(1),
    metadata: z.record(z.unknown()).optional(),
})
